var _div;
import { memo } from "react";
import { Skeleton } from "@crehana/compass.ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CourseCardSkeleton = function CourseCardSkeleton() {
  return _div || (_div = /*#__PURE__*/_jsxs("div", {
    role: "presentation",
    className: "tw-relative tw-flex tw-items-center tw-py-0.8 tw-px-1.2 tw-rounded-1",
    children: [/*#__PURE__*/_jsx(Skeleton, {
      className: "tw-w-12 tw-min-w-12 tw-h-8 tw-mr-1.2 tw-rounded-0.4 tw-overflow-hidden",
      animated: true
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-w-full",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-[70%] tw-h-1.6 tw-mb-1",
        animated: true
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-20 tw-h-1.6 tw-mb-1",
        animated: true
      }), /*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-11.2 tw-h-1.6",
        animated: true
      })]
    })]
  }));
};
export default /*#__PURE__*/memo(CourseCardSkeleton);